<template>
    <div>
        <div v-if="loading">
            Loading...
        </div>
        <div v-else class="vx-row flex justify-center">
            <div class="vx-col sm:w-4/5 lg:w-2/3 md:w-3/4">
                <vx-card title="" >

                    <div slot="no-body">
                        <img src="https://image.freepik.com/vector-gratis/robot-operando-paciente-cirujanos-que-monitorean-trabajo-brazos-roboticos-quirofano_74855-14152.jpg" alt="content-img" class="responsive card-img-top">
                    </div>
                    
                    <div v-if="hasActiveSec" style="margin-top: -50px;">
                        <h5>Nuev@ Secretari@</h5>
                        <p class="mt-2">¡Hola! Por favor completa la siguiente información para crear tu perfil como secretari@.</p>
                    </div>

                    <div class="mt-2">
                        <form-wizard color="rgba(var(--vs-primary), 1)"
                            :title="null" :subtitle="null"
                            backButtonText="Regresar"
                            next-button-text="Siguiente"
                            finishButtonText="Envíar"
                        >
                            <tab-content title="Datos" class="mb-5" :before-change="validateSecData">
                                <!--:before-change=" validatePatientData" -->
                                    <form data-vv-scope="sec-data">
                                    <!-- tab 1 content -->
                                    <div class="vx-row">
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Nombre(s)*</p>
                                            <vs-input placeholder="Nombre(s)" v-model="secData.first_name" name="nombres" v-validate="'required'" class="w-full" />
                                            <span class="text-danger">{{ errors.first('sec-data.nombres') }}</span>
                                        </div>
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Apellido(s)*</p>
                                            <vs-input placeholder="Apellido(s)" v-model="secData.last_name" name="apellidos" v-validate="'required'" class="w-full" />
                                            <span class="text-danger">{{ errors.first('sec-data.apellidos') }}</span>
                                        </div>
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Correo*</p>
                                            <vs-input placeholder="Correo" v-model="secData.email"
                                             :disabled="hasActiveSec"
                                             name="email" v-validate="'required|email'" class="w-full" />
                                            <span class="text-danger">{{ errors.first('sec-data.email') }}</span>
                                        </div>
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Sexo*</p>
                                            <ul class="ml-2 mt-2 flex">
                                                <li class="ml-3 mb-2 inline">
                                                    <vs-radio v-model="secData.gender" name="genero" v-validate="'required'" vs-value="male">
                                                    Másculino
                                                    </vs-radio>
                                                </li>
                                                <li class="ml-3 mb-2">
                                                    <vs-radio v-model="secData.gender" name="genero" v-validate="'required'" vs-value="female">
                                                    Femenino
                                                    </vs-radio>
                                                </li>
                                            </ul>
                                            <span class="text-danger">{{ errors.first('sec-data.genero') }}</span>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <p>Fecha de Nacimiento*</p>
                                            <flat-pickr class="w-full" :config="configdateTimePicker2" v-model="secData.dob" placeholder="Seleccionar Fecha"
                                                    v-validate="'required'" name="fecha" />
                                                <span class="text-danger w-full">{{ errors.first('patient-data.fecha') }}</span>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <p class="mb-1">Número Celular*</p>
                                            <div class="vx-row">
                                                <!--- <div class="vx-col w-1/3">
                                                    <v-select placeholder="Código de Extensión" class="w-full" name="codigo" v-validate="'required'" v-model="secData.meta.phoneExt[0]" :options="['+502','+503', '+504', '+505']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                                    <vs-input class="inputx w-full" placeholder="Código de área" name="codigo" v-validate="'required'" v-model="secData.meta.phoneExt[0]" />
                                                    <span class="text-danger">{{ errors.first('sec-data.codigo') }}</span>
                                                </div> --->
                                                <div class="vx-col w-2/3 ">
                                                    <vs-input class="inputx w-full" placeholder="Número de teléfono" name="celular" v-validate="'required|numeric'" v-model="secData.phone[0]" />
                                                    <span class="text-danger">{{ errors.first('sec-data.celular') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <p>Identificación</p>
                                            <div class="vx-row">
                                                <div class="vx-col w-1/3">
                                                    <v-select placeholder="Documento" v-model="secData.meta.personal_id_type"
                                                    :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                                </div>
                                                <div class="vx-col w-2/3 ">
                                                    <vs-input class="inputx w-full" placeholder="Número de identificación" v-model="secData.meta.personal_id" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-col w-full mt-6">
                                            <h5>Dirección de Residencia</h5>
                                            <p class="mt-3">Dirección</p>
                                            <vs-input type="text" placeholder="Dirección"  v-model="secData.address" class="w-full" />
                                            <p class="mt-3">Complemento de dirección</p>
                                            <vs-input type="text" placeholder="Complemento de Dirección"  v-model="secData.address_2" class="w-full" />
                                            <p class="mt-3">Zona</p>
                                            <vs-input type="text" placeholder="Zona"  v-model="secData.zone" class="w-full" />
                                            <p class="mt-4">País</p>
                                            <v-select placeholder="Selecciona el País" label="name" v-model="secData.country" class="" :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                            <p class="mt-4">Ciudad</p>
                                            <v-select placeholder="Selecciona la Ciudad/Estado" class="" v-model="secData.city" :options="getStates" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                        </div>
                                        <div class="vx-col  w-full mt-6 mb-2">
                                            <h5 class="my-2">Biografía</h5>
                                            <p>Agrega una breve descripción con información importante para tu perfil.</p>
                                            <div class="vx-row ">
                                                <div class="vx-col flex flex-col items-center w-full">
                                                        <vs-textarea v-model="secData.meta.about" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </tab-content>

                            <!-- tab 2 content -->
                            <tab-content title="Confirmación" class="mb-5" :before-change="validateLastStep">
                                <form data-vv-scope="last-step">
                                    <div class="vx-row">
                                        <div class="vx-col  w-full mt-5"> 
                                            <h4>Verificar Información</h4>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <h5>Información Personal</h5>
                                        </div>
                                        <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-5 ml-4">
                                            <h6 class="inline mr-2">Nombres:</h6>
                                            <p class="inline"> {{secData.first_name}} </p>
                                        </div>
                                        <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Apellidos:</h6>
                                            <p class="inline"> {{secData.last_name}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Correo Electrónico:</h6>
                                            <p class="inline"> {{secData.email}} </p>
                                        </div>
                                        <div class="vx-col  w-full md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Sexo:</h6>
                                            <p class="inline"> {{secData.gender}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Fecha de Nacimiento:</h6>
                                            <p class="inline"> {{secData.dob}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Celular de Contacto:</h6>
                                            <p class="inline"> {{"502"}} {{secData.phone[0]}}  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="secData.meta.personal_id">
                                            <h6 class="inline mr-2">Identificación:</h6>
                                            <p class="inline"> {{secData.meta.personal_id_type}} {{secData.meta.personal_id}}  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="secData.address">
                                            <h6 class="mr-2">Dirección de Residencia:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-6" v-if="secData.country && secData.city">
                                            <p class="inline"> {{secData.address}} {{secData.address_2 ? ', '+secData.address_2 : ''}} </p>
                                            <p v-if="secData.zone">, {{`Zona: ${secData.zone} `}} , {{secData.country.name}}, {{secData.city}}</p>
                                        </div>
                                        <vs-divider></vs-divider>
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2 py-0">
                                                <img src="https://image.freepik.com/vector-gratis/ilustracion-concepto-inicio-sesion-seguro_114360-4685.jpg" alt="" style="width: 100%">
                                            </div>
                                            <div class="vx-col w-1/2 pt-6 px-0">
                                                <p>Te enviarémos un correo para puedas crear tu contraseña segura.</p>
                                            </div>
                                        </div>
                                        <vs-divider></vs-divider>
                                        <div class="vx-col w-full mt-5 flex flex-col items-center">
                                            <h6 class="my-3">Términos y Condiciones</h6>
                                            <a href="/pages/doctor/terms-cond" target="_blank" class="mt-3">
                                                <feather-icon icon="ExternalLinkIcon" class="mr-2" />
                                                Consultar términos y Condiciones
                                            </a>
                                            <ul class="centerx">
                                                <li>
                                                <vs-checkbox class="mt-4" name="terminos_condiciones" v-validate="'required'" v-model="termsCond">Acepto los términos y Condiciones</vs-checkbox>
                                                <span class="text-danger">{{ errors.first('last-step.terminos_condiciones') }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <vs-divider></vs-divider>
                                    </div>
                                </form>
                                
                            </tab-content>
                        </form-wizard>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import Calendar from 'v-calendar/lib/components/calendar.umd'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const ES = require("flatpickr/dist/l10n/es.js").default.es;

// country state picker functions
import * as CSP from 'country-state-picker';

export default {
  data () {
    return {
      secData: {
          first_name: null,
          last_name: null,
          gender: null,
          dob: null,
          phone: [],
          email: null,
          address: null,
          address_2: null,
          country: {},
          role: 'secretary',
          active: true,
          city: null,
          meta: {
              personal_id: null,
              personal_id_type: null,
              phoneExt: [],
              about: null
          }
      },
        configdateTimePicker2: {
            enableTime: false,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd M Y',
            defaultDate: new Date(),
            locale: ES
      },
      currentSecData: {},
      termsCond: null,
      consent: null,
      hasActiveSec: false,
      loading: true,
    }
  },
  methods: {
    submitData () {
        this.secData.active = true; 

        if(this.secData.country.name){
            this.secData.country = this.secData.country.name;
        }
        
        if(this.hasActiveSec){
            this.$store.dispatch('editUserPublic', this.secData).then(response => {
            console.log(response); 
             const payload = {   
                email: this.secData.email,
            }
            this.$store.dispatch('auth/sendPasswordRecoveryEmail', payload).then((response) => {
                window.location.href = '/links/confirm-sec';
                console.log(response);
            })
                                    
        }, error => {
            console.error(error.response);
            
        });
        } else {
            // this.secData.meta.doctor_id = this.$route.params.doctor_id;
            // this.$store.dispatch('registerPatientPublic', this.secData).then(response => {
                
            //     console.log(response);
            //     window.location.href = '/links/confirm-p';  
                            
            // }, error => {
            //     console.error(error.response);
                
            // });
        }
    },
    validateSecData(type) {
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('sec-data').then(result => {
                if (result) {
                    this.scroll();
                    resolve(true);
                    
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    validateLastStep(type) {
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('last-step').then(result => {
                if (result) {
                    this.submitData();
                    this.scroll();
                    resolve(true);
                    
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    scroll(){
       window.scroll({
        top: 130,
        left: 0,
        behavior: 'smooth'
      });
    },
  },
  computed: {
    getCountries(){
      return CSP.getCountries();
    },
    getStates(){
      return CSP.getStates(this.secData.country.code);
    },
  },
  created(){
      console.log(this.$route);
      if(this.$route.params.secretary_id){
          console.log(this.$route.params.secretary_id);
          this.hasActiveSec = true;
        this.$store.dispatch('getUserDataByIdPublic', this.$route.params.secretary_id).then(response => {
                console.log(response);
                this.currentSecData = JSON.parse(JSON.stringify(response.data.data.user));
                var tempMeta = {...this.secData.meta, ...this.currentSecData.meta};
                this.secData = {...this.secData, ...this.currentSecData};

                this.secData.meta = tempMeta;
                console.log(this.secData)
                this.loading = false;
            }, error => {
                console.error(error);
            }
        ); 
      } else { 
          this.loading = false;
          this.hasActiveSec = false;
      }
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    vSelect,
    Calendar,
    flatPickr
  }
}
</script>
<style scoped>
body{
        touch-action: manipulation;
    }
</style>